import { render, staticRenderFns } from "./MobFundHoldingSummary.vue?vue&type=template&id=27dffba9&scoped=true"
import script from "./MobFundHoldingSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./MobFundHoldingSummary.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobFundHoldingSummary.vue?vue&type=style&index=0&id=27dffba9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dffba9",
  null
  
)

export default component.exports